@file:OptIn(InternalResourceApi::class)

package bds_pack_manager.site.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/bds_pack_manager.site.generated.resources/"

internal val Res.font.HarmonyOS_Sans_SC_Regular: FontResource by lazy {
      FontResource("font:HarmonyOS_Sans_SC_Regular", setOf(
        ResourceItem(setOf(), "${MD}font/HarmonyOS_Sans_SC_Regular.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectJsMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("HarmonyOS_Sans_SC_Regular", Res.font.HarmonyOS_Sans_SC_Regular)
}
